//#region Styles
import { Container, Content, Icon } from "./styles";
//#endregion
//#region Icons
import ErrorIcon from "icons/ErrorIcon";
import CheckIcon from "icons/CheckIcon";
//#endregion

const Message = ({
    success, 
    quantityErrors, quantityRows
}) => {
    return (
        <Container>
            <Icon>
                {success 
                    ? <CheckIcon/>
                    : <ErrorIcon/>}
            </Icon>
            <Content>
                <h4>
                    {success 
                        ? "¡Felicitaciones!"
                        : "Tenemos algunos problemas con tu documento"}
                </h4>
                <p>
                    {success 
                        ? `No hay errores en tu(s) ${quantityRows} registro(s).`
                        : quantityRows > 0 
                            ? `Hemos encontrado ${quantityErrors} error(es) en tu documento:`
                            : "No existen registros en tu archivo"}
                </p>
            </Content>
        </Container>
    );
}

export default Message;